import { reactive, Ref, ref, UnwrapRef, ComputedRef, computed } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import { IPRestrictionItem } from '@/renderer/scripts/libs/smh-sdk-class/typings';
import smh from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
export type IPRestrictionViewData = {
  ip: string;
  activeState: string;
  item: IPRestrictionItem;
};
type TableData = {
  list: IPRestrictionViewData[];
  selectedRowKeys: Array<Number | String>;
  selectedList: Array<object>;
};
type PageData = {
  currPage: number;
  pageSize: number;
  total: number;
  pageSizeOptions: Array<any>;
};
type Handler = {
  tableData: UnwrapRef<TableData>;
  pageData: UnwrapRef<PageData>;
  loading: Ref<boolean>;
  columns: ComputedRef<Array<any>>;
  ipAdminStatus: Ref<boolean>;
  methods: {
    pullList: () => Promise<void>;
    refresh: () => void;
    onPageSizeChange: (pageSize: number) => void;
    onCurrentChange: (current: number) => void;
  };
};
export default function IPRestrictionListHandler(): Handler {
  const columns = computed(() => [
    {
      colKey: 'ip',
      title: i18n_t('生效地址'),
      sortType: 'all',
      width: 280,
    },
    {
      colKey: 'activeState',
      title: i18n_t('状态'),
      width: 260,
      sortType: 'all',
    },
  ]);
  const tableData = reactive<TableData>({
    list: [],
    selectedRowKeys: [],
    selectedList: [],
  });
  const pageData = reactive<PageData>({
    currPage: 1,
    pageSize: 20,
    total: 0,
    pageSizeOptions: [
      {
        label: i18n_t('每页 {slot1} 条', { slot1: 20 }),
        value: 20,
      },
    ],
  });
  const loading = ref(false);
  const ipAdminStatus = ref(false);
  const methods = {
    async pullList() {
      loading.value = true;
      try {
        const opt = {
          page: pageData.currPage,
          pageSize: pageData.pageSize,
        };
        const { data: listRes } = await smh.userAPI.getIPRestrictionList(opt);
        pageData.total = listRes.totalNum;
        const viewDataList: IPRestrictionViewData[] = [];
        listRes.contents.forEach((item: IPRestrictionItem) => {
          const viewData: IPRestrictionViewData = {
            ip: item.rule.startIp,
            activeState: item.enabled ? i18n_t('生效中') : i18n_t('未生效'),
            item,
          };
          if (item.rule.endIp) {
            if (item.rule.endIp.length > 0) {
              viewData.ip = `${item.rule.startIp}-${item.rule.endIp}`;
            }
          }
          viewDataList.push(viewData);
        });
        tableData.list = viewDataList;
        const { data: adminStatusRes } = await smh.userAPI.getIPAdminStatus();
        // limitAdmin 等于限制管理员登陆，ipAdminStatus等于不限制登陆，所以取反
        ipAdminStatus.value = !Boolean(adminStatusRes.limitAdmin);
        loading.value = false;
      } catch (error: MsgError) {
        loading.value = false;
        tips.error(error);
      }
    },
    clearSelectedAndPullList() {
      tableData.selectedRowKeys = [];
      tableData.selectedList = [];
      methods.pullList();
    },
    refresh() {
      tableData.list = [];
      tableData.selectedRowKeys = [];
      tableData.selectedList = [];
      methods.pullList();
    },
    onPageSizeChange(pageSize: number) {
      pageData.pageSize = pageSize;
      methods.pullList();
    },
    onCurrentChange(current: number) {
      pageData.currPage = current;
      methods.pullList();
    },
  };
  methods.pullList();
  return {
    columns,
    tableData,
    pageData,
    loading,
    ipAdminStatus,
    methods,
  };
}
